import { ReactElement } from 'react';

import pluralize from 'pluralize';

import { EvSelectNew, OptionType } from '@evinced-private/ui-common';

import './LabelsSelect.scss';

interface ILabelsSelect {
	labelKey: string;
	options: OptionType[];
	value: OptionType[];
	onChange: (selected: OptionType[]) => void;
	isMulti?: boolean;
	placeholder?: string;
	ariaLabel?: string;
	description?: string;
}

export const LabelsSelect = ({
	labelKey,
	options,
	value,
	onChange,
	isMulti = false,
	placeholder = 'Select an option',
	ariaLabel = 'Select dropdown',
	description = null
}: ILabelsSelect): ReactElement => {
	return (
		<EvSelectNew
			id={labelKey}
			label={ariaLabel}
			options={options}
			selectedValue={value}
			onSelectChange={onChange}
			isMultiple={isMulti}
			tooltipContent={description}
			className="labels-select"
			placeholder={placeholder}
			ariaLabel={ariaLabel}
			listboxWidth="100%"
			someItemsSelectedText={(numberOfItems: number) =>
				`${pluralize(ariaLabel, numberOfItems, true)} (${numberOfItems})`
			}
			allSelectedPlaceholder={`All ${pluralize(ariaLabel, options.length)}`}
		/>
	);
};
